import axios from "axios";
import {
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_REGISTER_FAIL,
  USER_REGISTER_REQUEST,
  USER_REGISTER_SUCCESS,
  USER_UPDATE_PROFILE_FAIL,
  USER_UPDATE_PROFILE_REQUEST,
  USER_UPDATE_PROFILE_SUCCESS,
  USER_DETAILS_RESET,
  USER_LIST_FAIL,
  USER_LIST_SUCCESS,
  USER_LIST_REQUEST,
  USER_LIST_RESET,
  USER_DEVLIST_FAIL,
  USER_DEVLIST_SUCCESS,
  USER_DEVLIST_REQUEST,
  USER_DEVLIST_RESET,
  USER_EMPLIST_FAIL,
  USER_EMPLIST_SUCCESS,
  USER_EMPLIST_REQUEST,
  USER_EMPLIST_RESET,
  USER_BUILDLIST_FAIL,
  USER_BUILDLIST_SUCCESS,
  USER_BUILDLIST_REQUEST,
  USER_BUILDLIST_RESET,
  USER_HIRELIST_FAIL,
  USER_HIRELIST_SUCCESS,
  USER_HIRELIST_REQUEST,
  USER_HIRELIST_RESET,
  USER_DELETE_REQUEST,
  USER_DELETE_SUCCESS,
  USER_DELETE_FAIL,
  USER_UPDATE_FAIL,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_REQUEST,
  USER_FORGOTPASS_FAIL,
  USER_FORGOTPASS_SUCCESS,
  USER_FORGOTPASS_REQUEST,
  USER_RESETPASS_FAIL,
  USER_RESETPASS_SUCCESS,
  USER_RESETPASS_REQUEST,
} from "../constants/userConstants";
import Api from "../Api";

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${Api}/api/users/login`,
      { email, password },
      config
    );

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: res.data,
    });

    localStorage.setItem("userInfo", JSON.stringify(res.data));
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("userInfo");
  dispatch({ type: USER_LOGOUT });
  dispatch({ type: USER_DETAILS_RESET });
  dispatch({ type: USER_LIST_RESET });
};

export const register = (name, email, password, role, history) => async (
  dispatch
) => {
  try {
    dispatch({
      type: USER_REGISTER_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };


    const res = await axios.post(
      `${Api}/api/users/register`,
      { name, email, password, role },
      config
    );


    dispatch({
      type: USER_REGISTER_SUCCESS,
      payload: res.data,
    });

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: res.data,
    });

    localStorage.setItem("userInfo", JSON.stringify(res.data));

    // history.push("/developer/request");
  } catch (error) {
    dispatch({
      type: USER_REGISTER_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const getUserDetails = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DETAILS_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/users/single`, config);

    dispatch({
      type: USER_DETAILS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: USER_DETAILS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const updateUserProfile = (name, email) => async (
  dispatch,
  getState
) => {
  let avatar = email.trim().toUpperCase()[0];
  try {
    dispatch({
      type: USER_UPDATE_PROFILE_REQUEST,
    });

    let localItem = localStorage.getItem("userInfo");

    let parseItem = JSON.parse(localItem);

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.put(
      `${Api}/api/users/update`,
      { name, email },
      config
    );


    let newInfo = {
      _id: parseItem._id,
      name,
      email,
      avatar,
      role: parseItem.role,
      token: parseItem.token,
    };

    dispatch({
      type: USER_UPDATE_PROFILE_SUCCESS,
      payload: res.data,
    });

    localStorage.setItem("userInfo", JSON.stringify(newInfo));
  } catch (error) {
    dispatch({
      type: USER_UPDATE_PROFILE_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const forgotPassword = (email) => async (dispatch) => {
  try {
    dispatch({
      type: USER_FORGOTPASS_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(`${Api}/api/users/forgot`, { email }, config);


    dispatch({
      type: USER_FORGOTPASS_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: USER_FORGOTPASS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const resetPassword = (password, token, history) => async (
  dispatch
) => {
  try {
    dispatch({
      type: USER_RESETPASS_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const res = await axios.post(
      `${Api}/api/users/reset/${token}`,
      { password },
      config
    );


    dispatch({
      type: USER_RESETPASS_SUCCESS,
      payload: res.data,
    });

    history.push("/login");
  } catch (error) {
    dispatch({
      type: USER_RESETPASS_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listUsers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_LIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/users`, config);

    dispatch({
      type: USER_LIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: USER_LIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listDevUsers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DEVLIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/users/developers`, config);

    dispatch({
      type: USER_DEVLIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: USER_DEVLIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const listEmpUsers = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_EMPLIST_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const res = await axios.get(`${Api}/api/users/employers`, config);

    dispatch({
      type: USER_EMPLIST_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: USER_EMPLIST_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};

export const deleteUser = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: USER_DELETE_REQUEST,
    });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${Api}/api/admin/delete/${id}`, config);

    dispatch({ type: USER_DELETE_SUCCESS });

    window.location.reload();
  } catch (error) {
    dispatch({
      type: USER_DELETE_FAIL,
      payload:
        error.response && error.response.data.error
          ? error.response.data.error
          : error.message
          ? error.message
          : error.data,
    });
  }
};
